import {UnsubscribeBaseServiceModel} from "../UnsubscribeBaseService.model";
import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {UserPageModel} from "../../../models/user/user-page.model";
import {distinctUntilChanged, filter, map, takeUntil} from "rxjs/operators";

@Injectable()
export class AppDataClientService extends UnsubscribeBaseServiceModel {

  //region user-data
  user$ = new BehaviorSubject<UserPageModel>(null);
  orgId$ = new BehaviorSubject<string>(null);
  orgName$ = new BehaviorSubject<string>(null);
  //end region user-data

  //region language
  /**
   * Selectable lang from the UI.
   */
  lang$: BehaviorSubject<string> = new BehaviorSubject<string>('de');
  /**
   * The default language of the browser.
   */
  browserLang$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  //endregion language

  //region ui-rendering-options
  multilingualInputs$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  //end region ui-rendering-options

  //region operational values
  token$: BehaviorSubject<string> = new BehaviorSubject<string>(null); //usage? no subscription
  accessMode$: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  //endregion operational values

  constructor() {
    super();

    //region user-data
    // this.user$.pipe(takeUntil(this.unSubscribe$))
    //   .subscribe(user => console.dir(user));

    this.user$.pipe(
      takeUntil(this.unSubscribe$),
      filter(v => v !== null),
      distinctUntilChanged(UserPageModel.equals),
      map(UserPageModel.toOrgId)
    ).subscribe(orgId => {
      this.orgId$.next(orgId);
    });

    this.user$.pipe(
      takeUntil(this.unSubscribe$),
      filter(v => v !== null),
      distinctUntilChanged(UserPageModel.equals),
      map(UserPageModel.toOrgName)
    ).subscribe(orgName => this.orgName$.next(orgName));

    this.user$.next(UserPageModel.ofUser(JSON.parse(localStorage.getItem('currentUser'))));
    //region user-data

    //region language
    //'lang$' currently done in `AppData.ts` -> should be moved to here!
    //'browserLang$' currently done in `AppData.ts` -> should be moved to here!
    //endregion language

    //region ui-rendering-options
    //currently done in `AppData.ts` -> should be moved to here!
    //end region ui-rendering-options

    //region operational values
    //currently done in `AppData.ts` -> should be moved to here!
    //endregion operational values
  }

  getOrgObject(): {id: string, name: string} {
    return {id: this.orgId$.getValue(), name: this.orgName$.getValue()};
  }
}
